import { render, staticRenderFns } from "./ApplicationFeedbackView.vue?vue&type=template&id=85da077e&"
import script from "./ApplicationFeedbackView.vue?vue&type=script&lang=js&"
export * from "./ApplicationFeedbackView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports